import { IFieldState, IRecurlyFieldState, IListFieldState } from './index';
import IFFFChangeHandlerEvent from './IFFFChangeHandlerEvent';

export function isFieldState(
  fs: IFieldState | IRecurlyFieldState | IListFieldState
): fs is IFieldState {
  return (fs as IFieldState).value !== undefined;
}

interface IBaseField {
  errorMsg: string;
  hasError: boolean;
  isTouched: boolean;
  changeHandler: (event: IFFFChangeHandlerEvent) => void;
  blurHandler: () => void;
  focusHandler: VoidFunction;
  onSubmit: (error: string) => void;
  lastPostSubmitError: string;
}

export default IBaseField;
